import { OverlayContainer } from '@angular/cdk/overlay';
import { Injectable } from '@angular/core';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';

@Injectable({
  providedIn: 'root'
})
export class ThemeService {
  constructor(
    public overlayContainer: OverlayContainer,
    private matIconRegistry: MatIconRegistry,
    private domSanitizer: DomSanitizer
  ) {
    this.matIconRegistry.addSvgIconSetInNamespace(
      '',
      this.domSanitizer.bypassSecurityTrustResourceUrl('../assets/icons/sprite.svg')
    );
  }

  setTheme(theme) {
    this.overlayContainer.getContainerElement().classList.add(theme);
    return theme;
  }
}
